export const SM_PLATFORM = {
  linkedin: "LinkedIn",
  x: "X (Twitter)",
};